/*** IMPORTS FROM imports-loader ***/
var Promise = require("es6-promise");

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function promiseFinally(value, cb) {
    return Promise.resolve(value).then(value => Promise.resolve(cb()).then(() => value), reason => Promise.resolve(cb()).then(() => Promise.reject(reason)));
}
exports.default = promiseFinally;
//# sourceMappingURL=index.js.map
